import { createFileRoute, Outlet } from "@tanstack/react-router";
import { parseMessageSearch } from "../features/tread/permalink";
import { TreadView } from "../features/tread/TreadView";

export const Route = createFileRoute("/w/$ws/dm/$channel")({
  validateSearch: parseMessageSearch,
  component: () => (
    <>
      <TreadView channelId={Route.useParams().channel} kind="dm" messageId={Route.useSearch().m} />
      <Outlet />
    </>
  ),
});
